const TextAreaStyle = {
  FullWidth: 'fullWidth',
  Default: '_default',
};

export default TextAreaStyle;
